import './userAnalyticsPage.css';
import React, { useEffect } from 'react';
import { useApiData } from '../../../../contexts/apiService';
import { useDataManager } from '../../../../contexts/dataManager';
import AnalyticsAction from './analytics_item/analyticsItem';

const UserAnalyticsPage: React.FC = () => {
    const { apiData } = useApiData();
    const { requestTableData, hasTableData, isTableLoading } = useDataManager();

    useEffect(() => {
        if (!hasTableData('user_analytics')) {
            void requestTableData('user_analytics');
        }
    }, []);

    const count = apiData?.user_analytics?.length ?? 0;

    return (
        <div className="userAnalytics-summary">
            <p className="userAnalytics-label">Total data points</p>
            <strong className="userAnalytics-count">
                {count.toLocaleString()}
            </strong>
            <div className="userAnalytics-actionsContainer">
                <AnalyticsAction
                    events={apiData?.user_analytics ?? []}
                    actionName="page_view"
                    propertyKeys={['path']}
                />
                <AnalyticsAction
                    events={apiData?.user_analytics ?? []}
                    actionName="table_view"
                    propertyKeys={['tableName']}
                />
                <AnalyticsAction
                    events={apiData?.user_analytics ?? []}
                    actionName="edit_cell"
                    propertyKeys={['colName', 'tableName']}
                />
                <AnalyticsAction
                    events={apiData?.user_analytics ?? []}
                    actionName="table_filter_apply"
                    propertyKeys={['colName', 'tableName']}
                />
                <AnalyticsAction
                    events={apiData?.user_analytics ?? []}
                    actionName="tab_toggle"
                    propertyKeys={['selectedValue']}
                />
                <AnalyticsAction
                    events={apiData?.user_analytics ?? []}
                    actionName="excel_download"
                    propertyKeys={['tableName']}
                />
            </div>
        </div>
    );
};

export default UserAnalyticsPage;